import { Component } from "react";
import $ from "jquery";

export default class Script extends Component {
    componentDidMount() {
        $(".footer-links-wrapper h3").click(expandFooter);

        function expandFooter() {
            let windowWidth = $(window).width();
            let liLinks = $(".footer-links-wrapper h3");
            if (windowWidth < 768) {
                $(this).next().slideToggle();
                $(this).toggleClass("change");
                liLinks.removeClass("changeBorder");
                $(this).addClass("changeBorder");
            }
        }

        $(window).resize(function () {
            let windowWidth = $(window).width();
            if (windowWidth > 768) {
                $(".footer-links-wrapper h3").next().show();
                $(".footer-links-wrapper h3").removeClass("change");
                $(".footer-links-wrapper h3").removeClass("changeBorder");
            } else if (
                windowWidth < 768 &&
                $(".footer-links-wrapper h3").hasClass("change")
            ) {
                $(".footer-links-wrapper h3").hasClass("change").next().show();
            } else {
                $(".footer-links-wrapper h3").next().hide();

                $(".footer-links-wrapper h3").removeClass("change");
            }
        });

        $("button").click(function (e) {
            let hideNav = $("nav>a");
            let button = $("button");
            $(".downP").toggleClass("downPad");
            hideNav.toggleClass("changeb2");
            button.toggleClass("active");
        });
    }
    render() {
        return;
    }
}
